import { QuickResponsesClient } from "@amazon-connect/quick-responses";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** QuickResponsesClient: quick response search. Request-only. */
export const quickResponsesModule: ClientModule = {
  id: "quick-responses",
  label: "Quick Responses",
  pkg: "@amazon-connect/quick-responses",
  clientExport: "QuickResponsesClient",
  kind: "request-only",
  create: (provider: AmazonConnectProvider) =>
    new QuickResponsesClient({ provider }) as unknown as Record<
      string,
      unknown
    >,
  events: [],
  requests: [
    { name: "isEnabled", args: [] },
    {
      name: "searchQuickResponses",
      args: [{ k: "queryRequest", type: "json", required: true }],
    },
  ],
};
